import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import moment from 'moment';
import { StripePaymentOnboardingPopup } from './stripe-payment-onboarding-popup';
import { useToggle } from '../../../infra/small-tools/use-toggle';
import { useRouteQuery } from '../../../infra/routing';
import { useStripeHostedOnboardingInfo } from '../hooks/use-stripe-hosted-onboarding-info';
import { STRIPE_ONBOARDING_RETURN_SEARCH_PARAM } from '../types';
import { persistentKVStore } from '../../../infra/persistence';
import { useFeatureFlags } from '../../../infra/feature-flags';
var STRIPE_ONBOARDING_INFO_LAST_SHOWN = 'squire_stripeOnboardingInfoLastShown';
export var StripePaymentOnboardingContainer = function () {
    var modal = useToggle(false);
    var queryParams = useRouteQuery();
    var isRedirectedFromStripe = useState(!!queryParams[STRIPE_ONBOARDING_RETURN_SEARCH_PARAM])[0];
    var stripeHostedOnboarding = useFeatureFlags().stripeHostedOnboarding;
    var stripeHostedOnboardingInfo = useStripeHostedOnboardingInfo(stripeHostedOnboarding);
    useEffect(function () {
        if (isRedirectedFromStripe) {
            var lastShownAtRaw = persistentKVStore.getItem(STRIPE_ONBOARDING_INFO_LAST_SHOWN);
            var shownMoreThanADayAgo = lastShownAtRaw
                ? moment.duration(moment().diff(moment(lastShownAtRaw))).asHours() > 24
                : true;
            if (shownMoreThanADayAgo && (stripeHostedOnboardingInfo === null || stripeHostedOnboardingInfo === void 0 ? void 0 : stripeHostedOnboardingInfo.info)) {
                var stripeOnboardingState = stripeHostedOnboardingInfo.info.state;
                if (['pending', 'completed'].includes(stripeOnboardingState)) {
                    persistentKVStore.setItem(STRIPE_ONBOARDING_INFO_LAST_SHOWN, new Date().toISOString());
                    modal.setOn();
                }
            }
        }
    }, [stripeHostedOnboardingInfo === null || stripeHostedOnboardingInfo === void 0 ? void 0 : stripeHostedOnboardingInfo.info]);
    if (!modal.isOn) {
        return null;
    }
    return _jsx(StripePaymentOnboardingPopup, { onCloseHandler: modal.setOff });
};
